import React, { useState } from 'react'
import i18n from 'i18n-js'

import Input from '../../UI/Input/Input'
import EHPResult from '../EHPResult/EHPResult'

const DefaultForm = props => {

    const [form, setForm] = useState([
        {
            type: 'tel',
            id: 'HP',
            value: 1,
            label: i18n.t('hp_label'),
            maxLength: 5
        },
        {
            type: 'tel',
            id: 'DEF',
            value: 1,
            label: i18n.t('defense_label'),
            maxLength: 5
        }
    ])

    const [resultData, setResultData] = useState({
        HP: 1,
        DEF: 1
    })

    const updateForm = (evt, id) => {
        const val = parseInt(evt.target.value)
        const objIndex = form.findIndex(el => el.id === id)
        const newElement = {
            ...form[objIndex],
            value: !!val ? val : 0
        }
        const newForm = form.map(obj => obj.id === id ? newElement : obj)
        setForm(newForm)
        setResultData({
            ...resultData,
            [id]: val > 0 ? val : 1
        })
    }

    return <div className="DefaultForm">
        <div className="col-md-6 mx-auto">
            {form.map(el => <Input key={el.id} {...el} changed={evt => updateForm(evt, el.id)} />)}
        </div>
        <EHPResult {...resultData} basic={true} />
        <button type="button" className="back-button" onClick={props.back}>{i18n.t('back')}</button>
    </div>
}

export default DefaultForm